import React, { useState } from 'react';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from './firebase';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { motion, AnimatePresence } from 'framer-motion';

const Login = () => {
  const [email, setEmail] = useState('');
  const [pass, setPass] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  
  const navigate = useNavigate();
  const { login } = useAuth();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await signInWithEmailAndPassword(auth, email, pass);   
      login(); 
      navigate('/admin');
    } catch (err) {
      console.error(err);
      setError("Credenciales incorrectas. Verifica tu acceso.");
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-[#f8fafc] flex items-center justify-center p-6 relative overflow-hidden selection:bg-[#a6192e] selection:text-white">
      <div className="absolute top-[-10%] left-[-10%] w-80 h-80 bg-[#a6192e]/5 rounded-full blur-[100px]"></div>
      <div className="absolute bottom-[-10%] right-[-10%] w-[500px] h-[500px] bg-slate-200/50 rounded-full blur-[120px]"></div>

      <div className="relative w-full max-w-md">
        <div className="bg-white/80 backdrop-blur-2xl border border-white p-10 rounded-[3.5rem] shadow-[0_20px_50px_-12px_rgba(0,0,0,0.08)] transition-all duration-500 hover:shadow-[0_30px_60px_-12px_rgba(0,0,0,0.12)]">
          
          <div className="text-center mb-10">
            <div className="inline-block p-5 rounded-[2.2rem] bg-white shadow-xl shadow-gray-200/50 mb-8 border border-gray-50">
              <svg className="w-8 h-8 text-[#a6192e]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
              </svg>
            </div>
            
            <h2 className="text-4xl font-black text-slate-900 tracking-tighter italic uppercase leading-none">
              Grupo<span className="text-[#a6192e]">Diana</span>
            </h2>
            <p className="text-slate-400 mt-4 text-[10px] font-black uppercase tracking-[0.4em] italic">Panel de Control Privado</p>
          </div>

          <form onSubmit={handleLogin} className="space-y-6">
            <AnimatePresence>
              {error && (
                <motion.div 
                  initial={{ opacity: 0, y: -10 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0 }}
                  className="bg-red-50 border border-red-100 text-red-600 text-[10px] font-bold uppercase p-4 rounded-2xl text-center italic tracking-widest"
                >
                  {error}
                </motion.div>
              )}
            </AnimatePresence>

            <div className="space-y-2">
              <label className="text-[10px] font-black text-slate-500 uppercase tracking-[0.3em] ml-2">Correo</label>
              <input 
                type="email" 
                required
                placeholder="usuario@dianagrupo.com" 
                className="w-full bg-gray-50/50 border border-gray-100 p-5 rounded-3xl text-slate-900 outline-none focus:bg-white focus:border-[#a6192e] focus:ring-4 focus:ring-[#a6192e]/5 transition-all placeholder:text-slate-300 italic text-sm font-medium"
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>

            <div className="space-y-2">
              <label className="text-[10px] font-black text-slate-500 uppercase tracking-[0.3em] ml-2">Contraseña</label>
              <input 
                type="password" 
                required
                placeholder="••••••••" 
                className="w-full bg-gray-50/50 border border-gray-100 p-5 rounded-3xl text-slate-900 outline-none focus:bg-white focus:border-[#a6192e] focus:ring-4 focus:ring-[#a6192e]/5 transition-all placeholder:text-slate-300 text-sm"
                onChange={(e) => setPass(e.target.value)}
              />
            </div>

            <button 
              type="submit"
              disabled={loading}
              className="w-full py-5 bg-[#a6192e] text-white rounded-[2.2rem] font-black text-xs tracking-[0.3em] hover:bg-slate-900 active:scale-[0.98] transition-all shadow-xl shadow-[#a6192e]/20 flex items-center justify-center gap-3 group uppercase italic"
            >
              {loading ? 'Verificando...' : 'Acceder al Sistema'}
              {!loading && (
                <svg className="w-4 h-4 group-hover:translate-x-2 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M13 7l5 5m0 0l-5 5m5-5H6" />
                </svg>
              )}
            </button>
          </form>

          <div className="mt-12 text-center border-t border-gray-50 pt-8">
            <button 
              onClick={() => navigate('/')} 
              className="text-slate-400 text-[9px] font-black uppercase tracking-[0.2em] hover:text-slate-900 transition-colors flex items-center justify-center gap-3 mx-auto italic"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M10 19l-7-7m0 0l7-7m-7 7h18" /></svg>
              Volver al Catálogo Público
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;